(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function report(err) {
    if (window.clarity) { try { window.clarity('event', 'norra_cart_error'); window.clarity('set', 'cart_error', String(err)); } catch (e) {} }
    if (window.console) console.error(err);
  }

  /* Scroll reveals. Anything left unobserved stays visible, nothing can stay stuck hidden. */
  var revealEls = document.querySelectorAll('.reveal, [data-particles], .when__list');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Particles settling: shows the ion mechanism in the "how it works" panel. */
  document.querySelectorAll('[data-particles]').forEach(function (box) {
    var n = window.innerWidth < 768 ? 22 : 34;
    for (var i = 0; i < n; i++) {
      var s = document.createElement('span');
      var left = 6 + Math.random() * 88;
      var top = 6 + Math.random() * 58;
      s.className = 'spk';
      s.style.left = left + '%';
      s.style.top = top + '%';
      s.style.setProperty('--dx', (Math.random() * 18 - 9).toFixed(1) + 'px');
      s.style.setProperty('--fall', Math.round((box.clientHeight || 420) * (1 - top / 100) - 50) + 'px');
      s.style.setProperty('--t', (7 + Math.random() * 5).toFixed(1) + 's');
      s.style.setProperty('--dl', (Math.random() * -12).toFixed(1) + 's');
      box.appendChild(s);
    }
  });

  /* Slow drift on the dot-ring decoration. */
  var par = document.querySelectorAll('[data-parallax]');
  if (par.length && !reduce && 'IntersectionObserver' in window) {
    var active = [];
    var pio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var i = active.indexOf(e.target);
        if (e.isIntersecting && i < 0) active.push(e.target);
        if (!e.isIntersecting && i > -1) active.splice(i, 1);
      });
    });
    par.forEach(function (el) { pio.observe(el); });
    var tick = function () {
      active.forEach(function (el) {
        var r = el.getBoundingClientRect();
        el.style.transform = 'rotate(' + (r.top * 0.03).toFixed(2) + 'deg)';
      });
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  /* Gallery */
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var track = gal.querySelector('[data-gallery-track]');
    var thumbs = document.querySelectorAll('[data-gallery-go]');
    var count = track.children.length;
    function current() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) {
      i = (i + count) % count;
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }
    function mark() {
      var c = current();
      thumbs.forEach(function (t, i) { t.classList.toggle('is-on', i === c); });
    }
    var timer;
    track.addEventListener('scroll', function () { clearTimeout(timer); timer = setTimeout(mark, 60); }, { passive: true });
    gal.querySelector('[data-gallery-prev]').addEventListener('click', function () { go(current() - 1); });
    gal.querySelector('[data-gallery-next]').addEventListener('click', function () { go(current() + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-gallery-go'), 10)); });
    });
  });

  /* Cart drawer */
  var drawer = document.getElementById('cart-drawer');
  var lastFocus = null;
  function money(cents) {
    var n = cents / 100;
    return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : s;
    return d.innerHTML;
  }
  function render(cart) {
    var box = drawer.querySelector('[data-cart-lines]');
    drawer.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    var checkout = drawer.querySelector('[data-cart-checkout]');
    checkout.hidden = cart.item_count === 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if (!cart.items.length) {
      box.innerHTML = '<p class="drawer__empty">Your cart is empty.</p>';
      return;
    }
    box.innerHTML = cart.items.map(function (it, i) {
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      var t = (it.product_title || '').toLowerCase();
      var perk = it.original_price === 0;
      var name = t.indexOf('store credit') > -1 && it.variant_title ? it.product_title + ': ' + it.variant_title : it.product_title;
      var thumb;
      if (t.indexOf('shipping protection') > -1) {
        thumb = '<span class="dl__icon" style="display:grid;place-items:center;width:72px;height:72px;border-radius:10px;background:var(--frost)"><svg viewBox="0 0 24 24" width="44" height="44" fill="none" stroke="var(--teal-ink,#00D2BE)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l8 4v6c0 5.5-3.5 9-8 10-4.5-1-8-4.5-8-10V6l8-4z"/><path d="M9 12l2 2 4-4"/></svg></span>';
      } else if (t.indexOf('store credit') > -1) {
        thumb = '<span class="dl__icon" style="display:grid;place-items:center;width:72px;height:72px;border-radius:10px;background:var(--frost)"><svg viewBox="0 0 24 24" width="44" height="44" fill="none" stroke="var(--teal-ink,#00D2BE)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/><path d="M7 15h4"/></svg></span>';
      } else {
        thumb = it.image ? '<img src="' + esc(it.image) + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="72" height="72" style="mix-blend-mode:multiply">' : '<span></span>';
      }
      return '<div class="dl">' + thumb +
        '<div><div class="dl__t">' + esc(name) + '</div>' +
        (perk ? '<div style="margin-top:8px;font-size:15px;color:var(--ink-2)">Included' + (it.quantity > 1 ? ' &times; ' + it.quantity : '') + '</div>' : '<div class="dl__qty"><button type="button" data-line="' + (i + 1) + '" data-qty="' + (it.quantity - 1) + '" aria-label="Remove one ' + esc(it.product_title) + '">&minus;</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-line="' + (i + 1) + '" data-qty="' + (it.quantity + 1) + '" aria-label="Add one more ' + esc(it.product_title) + '">+</button></div>') + '</div>' +
        '<div class="dl__p">' + (perk ? 'Free' : money(it.final_line_price) + was) + '</div></div>';
    }).join('');
  }
  /* Free perks only come with a bundle, so they leave when the last paid item does. */
  function dropOrphans(cart) {
    var paid = cart.items.some(function (it) { return it.original_price > 0; });
    if (paid || !cart.items.length) return cart;
    return fetch(root + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function refresh() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render);
  }
  function openDrawer() {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    });
    drawer.querySelector('.drawer__panel').focus();
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, reduce ? 0 : 380);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener) {
      e.preventDefault();
      refresh().then(openDrawer).catch(function (err) { report(err); window.location.href = opener.getAttribute('href'); });
      return;
    }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    var q = e.target.closest('[data-line]');
    if (q) {
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(q.getAttribute('data-line'), 10), quantity: parseInt(q.getAttribute('data-qty'), 10) })
      }).then(function (r) { return r.json(); }).then(dropOrphans).then(render).catch(report);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (drawer.hidden) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key === 'Tab') {
      var f = drawer.querySelectorAll('a[href]:not([hidden]),button');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === drawer.querySelector('.drawer__panel'))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Offer form: a real add, then the drawer. Without JavaScript the form posts to /cart/add. */
  var form = document.querySelector('[data-offer-form]');
  if (form) {
    var btn = form.querySelector('[data-offer-submit]');
    var errBox = form.querySelector('[data-offer-error]');
    var syncLabel = function () {
      var checked = form.querySelector('[data-offer-radio]:checked');
      if (!checked) return;
      var key = checked.getAttribute('data-offer-radio');
      form.querySelectorAll('[data-cta]').forEach(function (l) {
        l.style.display = l.getAttribute('data-cta') === key ? 'inline' : 'none';
      });
    };
    form.addEventListener('change', syncLabel);
    syncLabel();
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errBox.hidden = true;
      var checked = form.querySelector('[data-offer-radio]:checked');
      if (!checked) return;
      var items = [{ id: parseInt(checked.value, 10), quantity: 1 }];
      var wrap = checked.closest('.offer');
      wrap.querySelectorAll('[data-addon]:checked').forEach(function (a) {
        items.push({ id: parseInt(a.getAttribute('data-addon'), 10), quantity: 1 });
      });
      var offerKey = checked.getAttribute('data-offer-radio');
      var bp = form.querySelector('[data-bundle-perks="' + offerKey + '"]');
      if (bp && bp.value) {
        bp.value.split(',').forEach(function (vid) {
          vid = vid.trim();
          if (vid) items.push({ id: parseInt(vid, 10), quantity: 1 });
        });
      }
      /* Shopify lists the newest line first, so the purifier goes in last to stay on top. */
      items.reverse();
      btn.setAttribute('aria-busy', 'true');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
          return j;
        });
      }).then(refresh).then(openDrawer).catch(function (err) {
        report(err);
        errBox.textContent = 'That didn\'t go through. Please try again.';
        errBox.hidden = false;
      }).then(function () { btn.removeAttribute('aria-busy'); });
    });
  }
})();
